module.exports = __webpack_public_path__ + "img/throw.e8054dd5.png";